/**
 * Owner: Masa Bayu
 * File: TopicsExplorerPanel.tsx
 * Date:Time: 2026-09-18 12:21
 * Description: Global Topic Explorer — Tier-1 quiet list (≠ category chip dump).
 */

import { listTier1Topics, resolveTopicLabel, type QxreadTopicNode } from '@qx/qxread-core';
import { LandingIcon } from '../home/marketplace/landing/LandingIcons';
import './topics-explorer.css';

export interface TopicsExplorerPanelProps {
  readonly onNavigate: (path: string) => void;
  readonly locale?: string;
}

export function TopicsExplorerPanel({ onNavigate, locale = 'en' }: TopicsExplorerPanelProps) {
  const topics = listTier1Topics();

  return (
    <section className="market-surface topics-explorer" aria-labelledby="route-title">
      <header className="market-surface__hero market-surface__hero--band">
        <p className="market-surface__eyebrow">Discover</p>
        <h2 id="route-title" className="market-surface__title">
          Topics
        </h2>
        <p className="market-surface__support">
          Global knowledge taxonomy — browse by subject. Topic ≠ genre ≠ publication type.
        </p>
        <label className="topics-explorer__search">
          <span className="visually-hidden">Search topics</span>
          <input
            type="search"
            name="topic-q"
            placeholder="Search topics…"
            autoComplete="off"
            aria-label="Search topics"
            disabled
          />
        </label>
      </header>

      <ul className="topics-explorer__list" aria-label="All topics">
        {topics.map((node) => (
          <TopicRow key={node.topicId} node={node} locale={locale} onNavigate={onNavigate} />
        ))}
      </ul>

      <p className="market-surface__note" role="note">
        Canonical topic IDs · multilingual labels · Taxonomy ≠ entitlement
      </p>
    </section>
  );
}

function TopicRow({
  node,
  locale,
  onNavigate,
}: {
  readonly node: QxreadTopicNode;
  readonly locale: string;
  readonly onNavigate: (path: string) => void;
}) {
  const label = resolveTopicLabel(node, locale);
  const href = `/topics/${node.topicId}`;
  return (
    <li>
      <a
        className="topics-explorer__row"
        href={href}
        onClick={(event) => {
          event.preventDefault();
          onNavigate(href);
        }}
      >
        <span className="topics-explorer__label">{label}</span>
        <span className="topics-explorer__chevron" aria-hidden="true">
          <LandingIcon name="chevronRight" size={12} />
        </span>
      </a>
    </li>
  );
}
